import {
  Component,
  OnInit,
  Output,
  EventEmitter
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { COMPANY_ASSOCIATED, PLATFORMS, RATINGS, ReviewFilters } from 'voxloud-types/dist/models/reviews';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-reviews-filters',
  templateUrl: './reviews-filters.component.html',
  styleUrls: ['./reviews-filters.component.scss']
})
export class ReviewsFiltersComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter<ReviewFilters>();
  form: UntypedFormGroup;
  public filters: ReviewFilters;
  public availableFilters = ['company_id', 'timestamp_from', 'timestamp_to', 'platform', 'rating_from', 'rating_to'];
  public usedFilters = ['is_company_associated'];
  public COMPANY_ASSOCIATED: string[] = COMPANY_ASSOCIATED;
  public PLATFORMS: string[] = PLATFORMS;
  public RATINGS: number[] = RATINGS;
  public startDay: NgbDate = this.ngbCalendar.getToday();
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ngbCalendar: NgbCalendar
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      is_company_associated: new UntypedFormControl(COMPANY_ASSOCIATED[1])
    });
  }

  public addFilter(index: number) {
    let filter: string = this.availableFilters[index];
    this.usedFilters.push(this.availableFilters[index]);
    this.availableFilters.splice(index, 1);

    switch (filter) {
      case 'platform':
        this.form.addControl(filter, new UntypedFormControl(PLATFORMS[0]));
      case 'rating_from':
        this.form.addControl(filter, new UntypedFormControl(RATINGS[0]));
      case 'rating_to':
        this.form.addControl(filter, new UntypedFormControl(RATINGS[4]));
      default:
        this.form.addControl(filter, new UntypedFormControl(''));
        break;
    }
  }

  public removeFilter(index: number) {
    let filter = this.usedFilters[index];
    this.availableFilters.push(this.usedFilters[index]);
    this.usedFilters.splice(index, 1);
    this.availableFilters.sort();

    this.form.removeControl(filter);
  }

  public emitFilters(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.form.valid) {
      let values = this.form.value;
      let filters: ReviewFilters = {
        ...values
      };
      if (values.timestamp_from) filters.timestamp_from = this.stringifyDate(values.timestamp_from);
      if (values.timestamp_to) filters.timestamp_to = this.stringifyDate(values.timestamp_to);
      this.filtersChanged.emit(filters);
    }
    else this.filtersChanged.emit({});
  }

  public updateFilters(index: number, oldIndex: number) {
    let toRemove: string = this.usedFilters[oldIndex];
    let toAdd: string = this.availableFilters[index];
    this.usedFilters[oldIndex] = this.availableFilters[index];
    this.availableFilters.splice(index, 1);

    this.availableFilters.push(toRemove);
    this.availableFilters.sort();
    this.form.removeControl(toRemove);
    switch (toAdd) {
      case 'platform':
        this.form.addControl(toAdd, new UntypedFormControl(PLATFORMS[0]));
      case 'rating_from':
        this.form.addControl(toAdd, new UntypedFormControl(RATINGS[0]));
      case 'rating_to':
        this.form.addControl(toAdd, new UntypedFormControl(RATINGS[4]));
      default:
        this.form.addControl(toAdd, new UntypedFormControl(''));
        break;
    }
  }

  public stringifyDate(date: NgbDate) {
    return `${date.year}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;
  }

  public resetFilters() {
    this.form = this.formBuilder.group({
      is_company_associated: new UntypedFormControl(COMPANY_ASSOCIATED[1])
    });
    this.availableFilters = ['company_id', 'timestamp_from', 'timestamp_to', 'platform', 'rating_from', 'rating_to'];
    this.usedFilters = ['is_company_associated'];
  }

}
